import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles({
  root: {
    position: 'absolute',
    display: 'inline-block',
    whiteSpace: 'pre',
    fontFamily: 'sans-serif',
    marginTop: -0.5,
    lineHeight: 1.1,
    zIndex: 10,
    transition: '0.1s ease all',
    padding: '10px 10px 0 10px',

    '&:hover':{
      backgroundColor: 'rgba(177, 234, 255, 0.3)',
      outline: '3px solid #00AAE9',
      padding: '10px 10px 0 10px',
    }
  },
  textCursor: {
    cursor: 'pointer',
  },
  outlined: {
    outline: '1px solid green',
  },
  transparent: {
    color: 'transparent',
    '&::-moz-selection': {
      color: 'transparent',
      backgroundColor: 'rgba(0,0,255,0.2)',
    },
    '&::selection': {
      color: 'transparent',
      backgroundColor: 'rgba(0,0,255,0.2)',
    },
  },
});

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
